import { API, getToken } from "@/api";
import { toast } from "sonner";

export const fmtH = (m) => (m == null ? "—" : `${m < 0 ? "-" : ""}${Math.floor(Math.abs(m) / 60)}h${String(Math.abs(m) % 60).padStart(2, "0")}`);
export const fdate = (s, opts) => new Date(String(s).slice(0, 10) + "T12:00:00").toLocaleDateString("fr-FR", opts || { weekday: "short", day: "2-digit", month: "short" });
export const addDays = (s, n) => { const d = new Date(s + "T12:00:00"); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export const weekBounds = (s) => { const d = new Date(s + "T12:00:00"); const from = addDays(s, -((d.getDay() + 6) % 7)); return { from, to: addDays(from, 6) }; };
export const monthBounds = (s) => { const d = new Date(s + "T12:00:00"); const from = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`; const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate(); return { from, to: `${from.slice(0, 8)}${String(last).padStart(2, "0")}` }; };
export const STATE = { out: ["Parti", "status-inactive"], in: ["En poste", "status-active"], break: ["En pause", "status-pending"] };
export const KIND_CLS = { in: "text-[#059669]", break_start: "text-[#B45309]", break_end: "text-[#059669]", out: "text-[#0A0A0A]" };

export const cellCls = (c) => {
  if (c.empty) return "bg-white text-[#ADB5BD]";
  if (c.state !== "out") return "bg-[#EFF3FF] text-[#002FA7] border-[#002FA7]/40";
  if (c.validated) return "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]";
  if (c.anomalies.length) return "bg-[#FFFBEB] text-[#92400E] border-[#FCD34D]";
  if (c.complete) return "bg-white text-[#0A0A0A]";
  return "bg-[#F8F9FA] text-[#495057]";
};

export async function downloadCsv(path, filename) {
  try {
    const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
    if (!res.ok) throw new Error();
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement("a"); a.href = url; a.download = filename; a.click(); URL.revokeObjectURL(url);
  } catch { toast.error("Export indisponible"); }
}

export function Field({ label, children, className = "" }) {
  return <div className={`space-y-1 ${className}`}><div className="text-[10px] uppercase tracking-wider font-semibold text-[#495057]">{label}</div>{children}</div>;
}

export function Kpi({ label, value, sub, icon: Icon, dark, accent, testid, onClick }) {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick} className={`p-5 border text-left ${dark ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "bg-white border-[#DEE2E6]"} ${onClick ? "hover:border-[#002FA7] transition-colors" : ""}`} data-testid={testid}>
      <div className={`flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-bold ${dark ? "text-[#FFD700]" : "text-[#868E96]"}`}>{Icon && <Icon className="h-3 w-3" />} {label}</div>
      <div className="font-display text-2xl font-black mt-2" style={accent && !dark ? { color: accent } : {}}>{value}</div>
      {sub && <div className={`text-[10px] mt-1 ${dark ? "text-white/50" : "text-[#868E96]"}`}>{sub}</div>}
    </Tag>
  );
}
